import { render } from "./RegisterAthleteModal.vue?vue&type=template&id=a222f688&scoped=true"
import script from "./RegisterAthleteModal.vue?vue&type=script&lang=js"
export * from "./RegisterAthleteModal.vue?vue&type=script&lang=js"

import "./RegisterAthleteModal.vue?vue&type=style&index=0&id=a222f688&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a222f688"]])

export default __exports__